module.exports = __webpack_public_path__ + "img/504-f3a5c2.png";